import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoaurangabadcab() {



const cardData =
{
  keyword: 'Pune to Aurangabad Cab Service',

  heading: 'Lotus Cab: Pune to Aurangabad Cab Service',

  headingDescription:
    "Lotus Cabs provides reliable and affordable Pune to Aurangabad Cab Service for business travel, family vacations, heritage tours, pilgrimage journeys, corporate travel, and one-way or round-trip bookings. Our fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, all driven by professional and experienced chauffeurs. With 24x7 booking assistance, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe long-distance highway travel, Lotus Cabs ensures a comfortable, convenient, and hassle-free journey to Aurangabad (Chhatrapati Sambhajinagar) and its world-famous attractions.",


  top: 'Top Places to Visit in Aurangabad (Sambhajinagar) with Lotus Cab',

topPlaces: [
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves, a UNESCO World Heritage Site, are among India's greatest archaeological and artistic treasures. The ancient Buddhist rock-cut caves feature beautifully preserved paintings, sculptures, monasteries, and prayer halls dating back more than 2,000 years. Travelers from Pune frequently include Ajanta in their Aurangabad tour to experience its remarkable history, architecture, and cultural significance."
    },
    {
        title: "Ellora Caves",
        description:
            "Ellora Caves are one of Maharashtra's most iconic UNESCO World Heritage Sites, showcasing magnificent Hindu, Buddhist, and Jain rock-cut monuments. The world-famous Kailasa Temple, carved from a single rock, is the highlight of the complex and attracts visitors from across the globe for its extraordinary craftsmanship and historical importance."
    },
    {
        title: "Grishneshwar Jyotirlinga",
        description:
            "Grishneshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva and an important pilgrimage destination located near Ellora Caves. The beautifully constructed temple is admired for its traditional architecture, spiritual atmosphere, and religious importance, making it an essential stop for devotees visiting Aurangabad."
    },
    {
        title: "Bibi Ka Maqbara",
        description:
            "Bibi Ka Maqbara is Aurangabad's most famous Mughal monument and is often referred to as the 'Mini Taj Mahal' because of its elegant architecture and beautiful gardens. Built in memory of Dilras Banu Begum, the monument attracts tourists interested in history, photography, and Mughal heritage."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort is one of India's most impressive hill forts, known for its remarkable military architecture, strong defensive structures, secret passages, and panoramic hilltop views. Visitors enjoy exploring the fort's fascinating history while experiencing one of Maharashtra's finest medieval monuments."
    },
    {
        title: "Panchakki",
        description:
            "Panchakki is a historic 17th-century water mill powered by an underground water system, demonstrating the remarkable engineering skills of the medieval era. The peaceful gardens, water features, and nearby Sufi shrine make it a popular attraction for tourists exploring Aurangabad's historical landmarks."
    },
    {
        title: "Aurangabad Caves",
        description:
            "Aurangabad Caves are a group of ancient Buddhist rock-cut caves carved into the hills overlooking the city. Featuring intricate sculptures, detailed carvings, and serene surroundings, the caves offer visitors an opportunity to explore the region's rich Buddhist heritage beyond Ajanta and Ellora."
    },
    {
        title: "Bhadra Maruti Temple",
        description:
            "Bhadra Maruti Temple, located near Khuldabad, is one of the few temples in India where Lord Hanuman is worshipped in a reclining posture. The temple holds great religious importance and is frequently visited by pilgrims traveling to Grishneshwar Jyotirlinga and the Ellora Caves."
    },
    {
        title: "Khuldabad",
        description:
            "Khuldabad is a historic town known as the 'Valley of Saints' and is home to the tomb of Mughal Emperor Aurangzeb along with several important Sufi shrines. Visitors often include Khuldabad in their itinerary to explore its spiritual heritage and historical significance while touring the Aurangabad region."
    },
    {
        title: "Jayakwadi Dam",
        description:
            "Jayakwadi Dam, built across the Godavari River, is one of Maharashtra's largest dams and a popular recreational destination near Aurangabad. The scenic reservoir, beautiful sunset views, landscaped gardens, and nearby Nath Sagar Bird Sanctuary make it an excellent destination for families, photographers, and nature lovers."
    }
],

  "services": [
    {
      "name": "Pune to Aurangabad Cab Service",
      "description": "Book Pune to Aurangabad cab service for safe and comfortable long-distance travel covering approximately 235 km via well-maintained highways. The service is available for one-way drop, round trip, and multi-day sightseeing tours. AC sedan, Ertiga, Innova Crysta, and SUV categories are offered depending on group size and comfort preference. Professional drivers experienced in intercity routes ensure smooth highway driving and timely arrival. Transparent per kilometer pricing includes clear breakdown of base fare, driver allowance, and toll charges. Suitable for family vacations, business travel, pilgrimage visits, and heritage tourism."
    },
    {
      "name": "Pune to Sambhajinagar Taxi Fare",
      "description": "Check updated Pune to Sambhajinagar taxi fare calculated on per kilometer basis with minimum daily running criteria. Fare depends on vehicle category, trip type, and travel duration. Clear billing structure ensures no hidden charges and includes driver allowance and highway toll information. Sedan and SUV options offer different comfort and luggage capacities for varied travel needs. Advance fare estimation helps travelers plan budget effectively for intercity journeys."
    },
    {
      "name": "Pune to Aurangabad One Way Cab",
      "description": "Affordable Pune to Aurangabad one way cab option ideal for passengers not returning the same day. Pay only for one-side distance and avoid unnecessary round-trip charges. Suitable for business relocation, airport transfers, and extended stays. Comfortable AC vehicles and experienced drivers ensure safe highway travel. Transparent pricing model supports stress-free booking decisions."
    },
    {
      "name": "Pune to Aurangabad Round Trip Taxi",
      "description": "Round trip taxi from Pune to Aurangabad available with flexible return schedule. Ideal for Ajanta-Ellora sightseeing, Grishneshwar darshan, and weekend tours. Multi-day rental plans reduce daily travel stress and allow relaxed exploration. Vehicles are well-maintained for long-distance reliability. Clear fare breakdown ensures predictable travel cost for families and tourists."
    },
    {
      "name": "Pune Airport to Aurangabad Taxi",
      "description": "Direct Pune Airport to Aurangabad taxi service for travelers arriving by flight. Timely pickup with luggage assistance ensures smooth departure from airport terminal. Suitable for corporate executives and tourists heading directly to Sambhajinagar. Professional drivers ensure safe and uninterrupted highway journey. Transparent billing includes distance-based fare calculation."
    },
    {
      "name": "Pune to Aurangabad Innova Crysta",
      "description": "Premium Innova Crysta booking for Pune to Aurangabad travel providing spacious seating and superior ride comfort. Ideal for larger families and corporate groups. Smooth suspension ensures comfortable long-distance highway travel. Adequate luggage space supports multi-day tours. Per km pricing ensures fare clarity before trip commencement."
    },
    {
      "name": "Pune to Aurangabad Ertiga Car Booking",
      "description": "Affordable Ertiga car booking from Pune to Aurangabad suitable for small families and budget-conscious travelers. AC comfort and adequate luggage space make it practical for intercity trips. Competitive per km pricing ensures cost efficiency. Professional drivers provide safe and reliable travel experience."
    },
    {
      "name": "Outstation Cab Pune to Sambhajinagar",
      "description": "Reliable outstation cab Pune to Sambhajinagar available for tourism, pilgrimage, and business travel. Flexible one-way and round-trip booking options available throughout the year. Vehicles are regularly serviced for highway reliability and passenger safety. Transparent fare structure eliminates hidden charges. Comfortable intercity travel ensures stress-free journey."
    }
  ],

  "tableData": [
    ["Pune to Aurangabad Cab Service", "Pune to Sambhajinagar Taxi Fare"],
    ["Pune to Aurangabad One Way Cab", "Pune to Aurangabad Round Trip Taxi"],
    ["Pune Airport to Aurangabad Taxi", "Pune to Aurangabad Innova Crysta"],
    ["Pune to Aurangabad Ertiga Car Booking", "Outstation Cab Pune to Sambhajinagar"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Reliable Intercity Travel",
      "WhyChoosedescription": "Safe and comfortable travel from Pune to Aurangabad with experienced highway drivers."
    },
    {
      "WhyChooseheading": "Transparent Per Kilometer Pricing",
      "WhyChoosedescription": "Clear billing structure with detailed fare breakdown and no hidden charges."
    },
    {
      "WhyChooseheading": "One Way & Round Trip Options",
      "WhyChoosedescription": "Flexible travel plans available for one-way drop or multi-day return journeys."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Categories",
      "WhyChoosedescription": "Sedan, Ertiga, Innova Crysta, and SUV options based on group size and comfort preference."
    },
    {
      "WhyChooseheading": "Airport Pickup Available",
      "WhyChoosedescription": "Convenient pickup from Pune Airport with timely departure for Sambhajinagar."
    },
    {
      "WhyChooseheading": "Well-Maintained AC Vehicles",
      "WhyChoosedescription": "Regularly serviced vehicles ensuring reliability for long-distance highway travel."
    },
    {
      "WhyChooseheading": "Ideal for Tourism & Pilgrimage",
      "WhyChoosedescription": "Suitable for Ajanta-Ellora tours, Grishneshwar darshan, and family vacations."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for booking confirmation and travel queries."
    }
  ]
}





const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Aurangabad cab service?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Aurangabad cab service for one-way and round trips with professional drivers and well-maintained vehicles for comfortable long-distance travel.',
  },
  {
    question: 'What is the distance between Pune and Aurangabad by cab?',
    answer: 'The distance from Pune to Aurangabad is approximately 235–250 km depending on the route. The travel time usually takes around 5 to 6 hours.',
  },
  {
    question: 'What are the charges for Pune to Aurangabad cab booking?',
    answer: 'Cab charges depend on vehicle type, trip type (one-way or round trip), and travel date. Lotus Cab provides transparent per km pricing with clear billing and no hidden fees.',
  },
  {
    question: 'Can I book a one-way cab from Pune to Aurangabad?',
    answer: 'Yes, Lotus Cab provides affordable one-way Pune to Aurangabad cab services so you only pay for the drop without return charges.',
  },
  {
    question: 'Which vehicles are available for Pune to Aurangabad travel?',
    answer: 'We offer Sedan options like Dzire and Etios, as well as SUVs like Ertiga and Innova Crysta for comfortable family and group travel.',
  },
  {
    question: 'Do you provide cab service for Ajanta and Ellora from Aurangabad?',
    answer: 'Yes, Lotus Cab also offers extended sightseeing services from Aurangabad to Ajanta Caves, Ellora Caves, Grishneshwar Temple, and other nearby attractions.',
  },
  {
    question: 'Are toll and parking charges included in the fare?',
    answer: 'Toll, parking, and state taxes are charged separately as per actuals. Lotus Cab ensures complete fare transparency before confirming your trip.',
  },
  {
    question: 'Is Pune to Aurangabad cab service available for business travel?',
    answer: 'Yes, we provide punctual and comfortable cab services for corporate and business travelers commuting between Pune and Aurangabad.',
  },
  {
    question: 'Can I book a multi-day round trip to Aurangabad?',
    answer: 'Absolutely. Lotus Cab offers flexible multi-day round trip packages for sightseeing, temple visits, and family vacations in Aurangabad.',
  },
  {
    question: 'How can I book Pune to Aurangabad cab service with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, number of passengers, and vehicle preference to receive instant fare details and confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Jadhav',
    feedback: 'Booked Lotus Cab for Pune to Aurangabad business trip. The ride was smooth, car was clean, and driver was punctual. Very professional service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meenal Patil',
    feedback: 'Excellent cab service from Pune to Aurangabad for our family trip to Ellora. Comfortable Innova and transparent pricing. Highly recommended.',
    rating: 5,
  },
];








































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Aurangabad Cab Service",
"image": "https://lotuscab.com/assets/images/pune-to-aurangabad-cab-service.jpg",
"description": "Book Pune to Aurangabad Cab Service with Lotus Cab for affordable, safe, and comfortable intercity travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6528"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-aurangabad-cab-service"
}
};









  return (
    <div>
      

<Helmet>
  <title>Pune to Aurangabad Cab Service | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Aurangabad Cab Service with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, professional drivers, instant booking, and 24x7 customer support."
/>

<meta
 name="keywords"
 content="Pune to Aurangabad Cab Service, Pune to Aurangabad Cab, Pune to Aurangabad Taxi, Pune to Aurangabad Taxi Service, Aurangabad Cab from Pune, One Way Cab Pune to Aurangabad, Round Trip Cab Pune to Aurangabad, Outstation Cab Pune to Aurangabad, Pune to Chhatrapati Sambhajinagar Cab, Affordable Pune to Aurangabad Cab, Cheap Pune to Aurangabad Taxi, Online Pune to Aurangabad Cab Booking, Sedan Cab Pune to Aurangabad, SUV Cab Pune to Aurangabad, Best Pune to Aurangabad Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoaurangabadcab;